import React from "react";
import {
  Flex,
  Text,
  Image,
  useBreakpointValue,
  FlexProps,
} from "@chakra-ui/react";
import Marquee from "react-fast-marquee";
import asterisk from "../../assets/asterisk.png";

type MarqueeProps = {
  categories: string[];
  bgColor: string;
  textColor: string;
  scrollDirection?: "left" | "right";
};

const row1Categories: string[] = [
  "Electricians",
  "Cleaners",
  "Plumbers",
  "Welders",
  "AC Technicians",
];

const row2Categories: string[] = [
  "Carpenters",
  "Painters",
  "Solar Technicians",
  "POP Workers",
];

const row3Categories: string[] = [
  "Furniture Makers",
  "Fumigators",
  "Aluminium Workers",
  "Masons",
];

export const RowMarquee: React.FC<FlexProps & MarqueeProps> = ({
  categories,
  bgColor,
  textColor,
  scrollDirection = "left",
  ...flexProps
}) => {
  const height = useBreakpointValue({ base: "52px", lg: "33.33%" });
  const fontSize = useBreakpointValue({ base: "17px", lg: "56px" });

  return (
    <Flex width="100%" height={height} bgColor={bgColor} {...flexProps}>
      <Marquee autoFill={true} direction={scrollDirection}>
        {categories.map((category: string) => (
          <Flex key={category} alignItems="center">
            <Text
              color={textColor}
              fontSize={fontSize}
              fontWeight={500}
              fontFamily="AeonikPro"
              fontStyle="medium"
              lineHeight="40px"
              ml={{ base: "16px", lg: "24px" }}
            >
              {category.toUpperCase()}
            </Text>
            <Image
              width={{ base: "10px", lg: "40px" }}
              height={{ base: "10px", lg: "40px" }}
              src={asterisk}
              alt="*"
              ml={{ base: "16px", lg: "24px" }}
            />
          </Flex>
        ))}
      </Marquee>
    </Flex>
  );
};

export default function SkilledWorkersMarquee() {
  return (
    <div className="h-full w-full">
      <RowMarquee
        bgColor={"#FBE2DE"}
        textColor={"#2F1612"}
        categories={row1Categories}
      />
      <RowMarquee
        bgColor={"#EEE6F8"}
        textColor={"#221A2C"}
        categories={row2Categories}
        scrollDirection={"right"}
      />
      <RowMarquee
        bgColor={"#DAEAF3"}
        textColor={"#221A2C"}
        categories={row3Categories}
      />
    </div>
  );
}
